import React from "react";
import AppHeader from "../../../../components/app-hero-header";

export default function TextArea() {
  return (
    <AppHeader title="Over ons én de stichting" background="achterkant.jpg" />
  );
}
